import * as faceapi from '@vladmandic/face-api/dist/face-api.esm.js';
import {PipelineResultImpl} from "./PipelineResult";
import {isMobile, MAX_RESOLUTION_HEIGHT} from "../hooks/useLiveness";
import {createElementImage, getVideoRatio, initDevice} from "../../../../utils";
import {validateImage} from "../../../../services/documentValidator";



function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split(',')[1]); // Obtiene solo la parte base64
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async function base64ToBlob(dataURL) {
    try {
      const [header, base64String] = dataURL.split(',');
      const mimeType = header.match(/:(.*?);/)[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
  
      return new Blob([byteArray], { type: mimeType });
    } catch (error) {
      console.error('Error al convertir Base64 a Blob:', error);
      throw error;
    }
  }
  


const cv = window.cv;
export class Detector {
    static croppedImage = true
    static imageNumber = 0
    static processId = ''
    static hasResponseToValidation = false
    constructor(stream, isMobile, modelPath, croppedImage, processId) {
        this.probabilityThreshold = 50;
        this.counterSuccessfulResults = 0;
        this.MAX_FPS_DETECTION = 500;
        this.rendering = {
            now: 0,
            elapsed: 0,
            then: 0,
        };
        this.MAX_NUMBER_FACES = 1;
        this.MAX_ANGLE_TURN_HEAD = 30;
        this.MIN_FACE_SIZE_FOR_MOBILE = 224;
        this.MIN_FACE_SIZE_FOR_DESKTOP = 350;
        this.MIN_OCCUPIED_SPACE_FOR_DESKTOP = 15;
        this.MIN_OCCUPIED_SPACE_FOR_MOBILE = 15;
        this.X_OFFSET_FROM_FRAME = 15;
        this.Y_OFFSET_FROM_FRAME = 5;
        this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
        this.videoRatio = 1;
        this.showDetectedFace = false;
        this.headTurnCounter = 0;
        this.counterSuccessfulHeadTurns = 0;
        this.stream = stream;
        this.isMobile = isMobile;
        this.modelPath = modelPath;
        this.croppedImage = croppedImage
        this.processId = processId
    }
    setProbabilityThreshold(val) {
        this.probabilityThreshold = val;
    }
    static getInstance(stream, isMobile, modelPath, croppedImage, processId) {
        if (!Detector.instance) {
            Detector.instance = new Detector(stream, isMobile, modelPath, croppedImage, processId);
        }
        return Detector.instance;
    }
    updateHtmlElements(videoElement) {
        this.videoElement = videoElement;
    }
    static async initDetector(modelPath) {
        /*await faceapi.tf.setBackend(this.BACKEND);
        await faceapi.tf.enableProdMode();
        await faceapi.tf.ENV.set('DEBUG', false);
        await faceapi.tf.ready();*/
        await this.loadingModels(modelPath);
        if (!cv)
            console.error("open cv not found");

    }
    static async loadingModels(modelPath) {
        if (!this.modelsLoaded()) {
            await faceapi.nets.tinyFaceDetector.load(modelPath);
            await faceapi.nets.faceLandmark68TinyNet.load(modelPath);
        }
    }
    static modelsLoaded() {
        return true// faceapi.nets.tinyFaceDetector.isLoaded && faceapi.nets.faceLandmark68TinyNet.isLoaded;
    }
    static async warmingUpModels() {
        // const image = new Image();
        // image.src = base64Photo;
        // await this.detectAllFaces(image);
    }
    static async resizeBase64(base64, width, height, quality, changeQuality = true) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                if (changeQuality) {
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                }

                canvas.toBlob(
                    (blob) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve({
                                blob,
                                base64: reader.result
                            });
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    },
                    'image/jpeg',
                    changeQuality ? quality : 1
                );
            };
            img.onerror = reject;
            img.src = base64;
        });
    }
    static async detectAllFaces(videoSrc, croppedImage, config) {
        if (this.hasResponseToValidation) {
            return
        }
    this.hasResponseToValidation = true
        let result = {
            croppedImage: '',
            originalImage: '',
            faces: [],
            error: null,
            size: {
                original: {
                    width: 0,
                    height: 0,
                },
                cropped: {
                    width: 0,
                    height: 0,
                }
            }
        };

        try {
            const width = videoSrc.videoWidth;
            const height = videoSrc.videoHeight;

            // Para responder, imagen grande
            const originalCanvas = document.createElement('canvas');
            originalCanvas.width = width;
            result.size.original.width = width
            originalCanvas.height = height;
            result.size.original.height = height
            const contextOriginal = originalCanvas.getContext('2d');
            contextOriginal.drawImage(videoSrc, 0, 0, originalCanvas.width, originalCanvas.height);

            const originalImage = originalCanvas.toDataURL('image/jpeg', 0.9);
            const blobImage = await base64ToBlob(originalImage);
            let response;
            try {
                response = await validateImage(blobImage, this.imageNumber, config.processId, config.deviceType, config.urlServiceLiveness)
            } catch (error) {
                console.log("Error al validar imagen: ", error)
                response = {}
            }
            this.imageNumber++;
            this.hasResponseToValidation = false
            result.originalImage = originalImage
            result.croppedImage = originalImage
            result.error = response?.data?.ErrorCode || null
            result.faces = true
            result.isAlive = response?.data?.isAlive || false
            return {result, response};
        }
        catch (e) {
            console.log('errrrororor', e)
            // bug in face api with canvas context 2d
        }
    }
    async startDetector() {
        if (!this.videoElement)
            throw Error("Video element not found");
        if (this.videoElement.clientWidth === 0)
            throw Error("Video element too small");
        this.rendering.then = Date.now();
        this.counterSuccessfulResults = 0;
        this.updateForIos();
        this.videoRatio = getVideoRatio(this.videoElement);
        this.requestAnimationFrame = requestAnimationFrame(() => this.detection());
    }
    stopDetector() {
        if (this.requestAnimationFrame) {
            // @ts-ignore
            cancelAnimationFrame(this.requestAnimationFrame); // TODO
            this.requestAnimationFrame = undefined;
            if (this.innerCanvas)
                this.innerCanvas.remove();
            this.innerCanvas = undefined;
        }
    }
    updateForIos() {
        const device = initDevice();
        if (device.isIos) {
            this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING = 1;
            this.MAX_FPS_DETECTION = 1000 / 2;
            Detector.isIos = true;
        }
    }
    async detection() {
        this.requestAnimationFrame = requestAnimationFrame(() => this.detection());
        this.rendering.now = Date.now();

        this.rendering.elapsed = this.rendering.now - this.rendering.then;
        if (this.rendering.elapsed > this.MAX_FPS_DETECTION) {
            this.rendering.then = this.rendering.now - (this.rendering.elapsed % this.MAX_FPS_DETECTION);
            const { result, response } = await Detector.detectAllFaces(this.videoElement, this.croppedImage, this.processId);

            // const faceErrors = await this.checkDetectedFaceOnError(detectionResult.faces);
            if (result) {
                if (result?.isAlive) {
                    this.counterSuccessfulResults++;
                    this.autoCapturing({images: {cropped: result.originalImage, original: result.originalImage, size: result.size}, response});
                }
                else {
                    this.counterSuccessfulResults = 0;
                    this.stream.returnErrors(result.error);
                }
            }
        }
    }
    async checkDetectedFaceOnError(detectedFaces) {
        const detectionFacesForSize = faceapi.resizeResults(detectedFaces, {
            width: this.videoElement.videoWidth,
            height: this.videoElement.videoHeight,
        });
        const pipelineResults = new PipelineResultImpl();
        const faceDetection = this.checkNumberFaces(detectionFacesForSize);
        pipelineResults["FACE_NOT_FOUND"] = !faceDetection && detectionFacesForSize.length === 0;
        pipelineResults["TOO_MANY_FACES"] = !faceDetection && detectionFacesForSize.length > this.MAX_NUMBER_FACES;
        if (faceDetection) {
            if (cv)
                // pipelineResults["FACE_ANGLE_TOO_LARGE"] = !this.checkHeadRotation(detectionFacesForSize);
            pipelineResults["PROBABILITY_TOO_SMALL"] = !this.checkProbability(detectionFacesForSize);
            pipelineResults["FACE_TOO_SMALL"] = !this.checkFaceSize(detectionFacesForSize);
            pipelineResults["FACE_CLOSE_TO_BORDER"] = !this.checkFaceIndent(detectionFacesForSize);
        }
        return pipelineResults;
    }
    autoCapturing(images) {
        if (Detector.debug) console.info(this.counterSuccessfulResults);
        if (this.counterSuccessfulResults >= this.DEFAULT_NUMBER_SUCCESSFUL_RESULTS_FOR_AUTO_CAPTURING) {
            this.stream.autoCapturing(images);
            this.counterSuccessfulResults = 0;
        }
    }
    // @ts-ignore TODO
    checkNumberFaces(detectionResult) {
        return detectionResult.length === this.MAX_NUMBER_FACES;
    }
    // @ts-ignore TODO
    checkProbability(detectionResult) {
        const score = detectionResult[0].detection.score;
        return score > +this.probabilityThreshold / 100;
    }
    // @ts-ignore TODO
    checkFaceSize(detectionResult) {
        const faceBox = detectionResult[0].detection.box;
        const { width, height, area } = faceBox;
        const { imageHeight, imageWidth } = detectionResult[0].detection;
        const occupiedSize = 100 / ((imageHeight * imageWidth) / area);
        const minSide = Math.min(width / this.videoRatio, height / this.videoRatio);
        return (minSide > (this.isMobile ? this.MIN_FACE_SIZE_FOR_MOBILE : this.MIN_FACE_SIZE_FOR_DESKTOP) &&
            occupiedSize > (this.isMobile ? this.MIN_OCCUPIED_SPACE_FOR_MOBILE : this.MIN_OCCUPIED_SPACE_FOR_DESKTOP));
    }
    // @ts-ignore TODO
    checkFaceIndent(detectionResult) {
        const faceBox = detectionResult[0].detection.box;
        const { imageHeight, imageWidth } = detectionResult[0].detection;
        const { top, left, bottom, right } = faceBox;
        const topIndent = top;
        const leftIndent = left;
        const rightIndent = imageWidth - right;
        const bottomIndent = imageHeight - bottom;
        return !(topIndent < this.Y_OFFSET_FROM_FRAME ||
            leftIndent < this.X_OFFSET_FROM_FRAME ||
            rightIndent < this.X_OFFSET_FROM_FRAME ||
            bottomIndent < this.Y_OFFSET_FROM_FRAME);
    }
    // @ts-ignore TODO
    checkHeadRotation(detectionResult) {
        /*const temporaryCanvas = document.createElement("canvas");
        const dims = faceapi.matchDimensions(temporaryCanvas, this.videoElement, true);
        temporaryCanvas.remove();
        const headPosition = new HeadPosition(detectionResult[0].landmarks.positions, dims);
        let angles = [0, 0, 0];
        try {
            angles = headPosition.estimateHeadPose();
        }
        catch (e) {
            // some error with open cv
        }
        if (angles[2] > this.MAX_ANGLE_TURN_HEAD || angles[2] * -1 > this.MAX_ANGLE_TURN_HEAD) {
            this.headTurnCounter++;
        }
        else {
            this.counterSuccessfulHeadTurns++;
            if (this.counterSuccessfulHeadTurns >= 5) {
                this.headTurnCounter = 0;
                this.counterSuccessfulHeadTurns = 0;
            }
        }
        return this.headTurnCounter <= 1;*/
    }
    drawFaces(data) {
        console.log(data);
        if (!this.innerCanvas) {
            this.createCanvasForDrawingMask(this.videoElement);
        }
        const canvas = this.innerCanvas;
        if (!canvas)
            return console.error("no canvas for drawing");
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;

    }
    createCanvasForDrawingMask(video) {
        this.innerCanvas = document.createElement("canvas");
        this.innerCanvas.className = "canvas-on-video";
        this.innerCanvas.width = video.videoWidth;
        this.innerCanvas.height = video.videoHeight;
        this.videoElement.after(this.innerCanvas);
        if (this.innerCanvas.offsetWidth) {
            this.innerCanvas.setAttribute("style", `margin-left:${-(this.innerCanvas.offsetWidth / 2)}px; margin-top: ${-(this.innerCanvas.offsetHeight / 2)}px;`);
        }
    }
}
Detector.tinyFaceDetectorOptions = new faceapi.TinyFaceDetectorOptions({ inputSize: 192 });
Detector.BACKEND = 'webgl';
Detector.debug = false;
